import React from 'react'
import { useSelector } from 'react-redux'
import { ETR_STATUS } from '../../constants'
import { isSQDStaff } from '../../helpers/roles'
import { DocumentDetailModel } from '../../models/documentDetail'
import { RootReducers } from '../../redux/reducers'
import ReceiptList from '../ReceiptList/ReceiptList'
import { AdditionalInfo } from '../detailPageComponent/additionalInfo'

export const MoreInfoComponent: React.FC<{ item: DocumentDetailModel }> = ({ item }) => {
  const loginData = useSelector((state: RootReducers) => state.loginReducer)
  const documentData = useSelector((state: RootReducers) => state.documentDetailReducer)

  const isNewETR = (): boolean => {
    return documentData.documentModel?.status === ETR_STATUS.NEW_ETR
  }

  const RequireAgentAO = ({ children }: any) => {
    if (loginData.account?.agentInfo.isAO && isNewETR()) {
      //console.log('RequireSQDRole', loginData.account?.agentInfo)
      return children
    }
    return <></>
  }

  const RequireSQDStaff = ({ children }: any) => {
    if (isSQDStaff(loginData.account?.agentInfo.role as string) && isNewETR()) {
      return children
    }
    return <></>
  }

  return (
    <>
      <RequireAgentAO agentInfo={loginData.account?.agentInfo}>
        <AdditionalInfo item={item}></AdditionalInfo>
        <ReceiptList documentDetail={item} />
      </RequireAgentAO>
      {/* <RequireBranchStaff>
        <AdditionalInfo item={item}></AdditionalInfo>
        <ReceiptList documentDetail={item} />
      </RequireBranchStaff> */}
      <RequireSQDStaff agentInfo={loginData.account?.agentInfo}>
        <AdditionalInfo item={item}></AdditionalInfo>
        <ReceiptList documentDetail={item} />
      </RequireSQDStaff>
    </>
  )
}
